import { JOB_TYPE_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import type { JobType, JobTypeListParams, JobTypeListResponse, JobTypePayload } from "./interface";

export const JobTypeService = {
  getAll: (params: JobTypeListParams): Promise<JobTypeListResponse> =>
    requests.get(`${JOB_TYPE_URL}`, params),
  create: (params: JobTypePayload): Promise<JobType> =>
    requests.post(`${JOB_TYPE_URL}`, params),
  getSingle: (id: number): Promise<JobType> =>
    requests.get(`${JOB_TYPE_URL}/${id}`),
  update: (params: JobTypePayload, id: number): Promise<JobType> =>
    requests.put(`${JOB_TYPE_URL}/${id}`, params),
  delete: (id: number): Promise<void> =>
    requests.delete(`${JOB_TYPE_URL}/${id}`),
};
